let audio,
    gameMemo, gameFrame,
    isFullscreen = false,
    isMemoSolved = false,
    totalMoves = 0,
    totalMistakes = 0;

class MemoryGame {

    constructor() {
        this.cardsContainer = document.querySelector(".js-cards");
        this.cards = Array.from(this.cardsContainer.children);
        this.flippedCards = [];
        this.delay = 500;

    }

    rearrangeCards() {
        this.cards.forEach(card => {
            const randomNumber =
                Math.floor(Math.random() * this.cards.length) + 1;

            card.classList.remove("has-match");
            card.style.opacity = '1';

            setTimeout(() => {
                card.style.order = `${randomNumber}`;
            }, 400);
        });
    }

    validateCards() {
        const [firstCard, secondCard] = this.flippedCards;

        this.cardsContainer.classList.add("no-event");

        if (firstCard.dataset.animal === secondCard.dataset.animal) {
            firstCard.classList.replace("flipped", "has-match");
            secondCard.classList.replace("flipped", "has-match");

            this.flippedCards = [];

            setTimeout(() => {
                const allHaveMatches = this.cards.every((card) =>
                    card.classList.contains("has-match"));

                this.cardsContainer.classList.remove("no-event");

                if (allHaveMatches) {
                    //this.rearrangeCards();
                    audio.completed.play();
                    stopAudioAfterDelay(audio.completed, 2000);
                    console.log('Błędów:' + totalMistakes, 'Total moves:' + totalMoves);
                }
            }, this.delay);
        } else {
            setTimeout(() => {
                firstCard.classList.remove("flipped");
                secondCard.classList.remove("flipped");

                this.flippedCards = [];

                gameFrame.style.borderColor = 'black';

                this.cardsContainer.classList.remove("no-event");
                audio.wrong.play();
                stopAudioAfterDelay(audio.wrong, 2000);

            }, this.delay);
        }
    }

    flip(selectedCard) {
        selectedCard.classList.add("flipped");

        this.flippedCards.push(selectedCard);

        if (this.flippedCards.length === 2) {
            this.validateCards();
        }
    }
}

function initGame() {
    gameFrame = document.querySelector('.game__frame');

    if (document.querySelector('.game__memo')) {

        loadUI();
        loadGame();

    }
}

function loadGame() {

    gameMemo = new MemoryGame();
    gameMemo.cards.forEach(card => {
        card.addEventListener("click", gameMemo.flip.bind(gameMemo, card));
    });

    $('.game__memo__card').on('click', function (e) {
        let valid = new Audio(this.dataset.sound);
        valid.play();
        stopAudioAfterDelay(valid, 2000);
        // audio.drag.play();
        totalMoves++;
        totalMistakes++;

        setTimeout(() => {
            gameFrame.style.borderColor = 'yellow';
        }, 200);

        if ($(this).hasClass('has-match')) {
            setTimeout(() => {
                //$('.game__card.has-match').css('opacity', 0);
                gameFrame.style.borderColor = 'green';

            }, 900);
            totalMistakes--;
            gameFrame.style.borderColor = 'green';

            audio.valid.play();
            stopAudioAfterDelay(audio.valid, 2000);
        }
    });
}

function stopAudioAfterDelay(audioElement, delay = 2000) {
    if (!audioElement) return;

    const timeoutId = setTimeout(() => {
        try {
            if (audioElement && !audioElement.paused) {
                audioElement.pause();
                audioElement.currentTime = 0;
            }
        } catch (error) {
            console.warn('Błąd podczas zatrzymywania audio:', error);
        }
    }, delay);

    audioElement.stopTimeoutId = timeoutId;

    return timeoutId;
}

function loadUI() {
    document.body.style.overflow = 'hidden';

    audio = {
        completed: new Audio('/wp-content/themes/neve/dist/audio/completed.mp3'),
        wrong: new Audio('/wp-content/themes/neve/dist/audio/wrong.mp3'),
        drag: new Audio('/wp-content/themes/neve/dist/audio/connect.wav'),
        valid: new Audio('/wp-content/themes/neve/dist/audio/ping.mp3'),
        start: new Audio('/wp-content/themes/neve/dist/audio/start.mp3')
    };

    let buttonFullscreen = gameFrame.querySelector('[data-toggle-fullscreen]'),
        buttonRestart = gameFrame.querySelector('[data-puzzle-restart]'),
        buttonBack = gameFrame.querySelector('[data-backward]');

    buttonFullscreen.addEventListener('click', () => {
        if (isFullscreen) {
            document.exitFullscreen();
            isFullscreen = false;
        } else {
            gameFrame.requestFullscreen();
            isFullscreen = true;
        }
        $(buttonFullscreen).find('i').toggleClass('fa-close fa-expand');
    });

    buttonRestart.addEventListener('click', () => window.location.reload());
    buttonBack.addEventListener('click', () => history.back());
}

export default {initGame};


// WEBPACK FOOTER //
// ./src/scripts/game-memo.js